import React, { useEffect } from 'react';

import { ForwardRequestForm } from '#/features/request-forwarding';
import { TimesheetApproval } from '#/features/timesheet-approval';
import { VerifyRequestForm } from '#/features/timesheet-verification';
import { useAccessToken } from '#/shared/hooks/useAccessToken';
import { usePageStateStore } from '#/shared/stores/pageStateStore';
import { useTimesheetActionViewStore } from '#/shared/stores/timesheetActionViewStore';

import { TimesheetActionsSelection } from './TimesheetActionsSelection';

type TimesheetActionsContainerProps = {
  actionsContainerRef: React.RefObject<HTMLDivElement | null>;
};

export function TimesheetActionsContainer({ actionsContainerRef }: Readonly<TimesheetActionsContainerProps>) {
  const token = useAccessToken();
  const pageState = usePageStateStore(state => state.pageState);
  const currentView = useTimesheetActionViewStore(state => state.currentView);
  const setView = useTimesheetActionViewStore(state => state.setView);

  // forward=true URL parameter handling sets the view to forward by default
  useEffect(() => {
    if (!token || pageState !== 'loading-success') {
      return;
    }
    if (window.location.search.includes('forward=true')) {
      setView('forward');
    }
  }, [token, pageState, setView]);

  return (
    <div ref={actionsContainerRef}>
      {currentView === 'actions' && (
        <>
          <TimesheetActionsSelection />
        </>
      )}

      {currentView === 'approve' && <TimesheetApproval />}

      {currentView === 'verify' && <VerifyRequestForm />}

      {currentView === 'forward' && <ForwardRequestForm />}
    </div>
  );
}
